var _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsKrDelivery = function SvgNnIconFlagsKrDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Lager 20",
    viewBox: "0 0 50.47 33.81"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.13.13h50.22v33.56H.13z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.639 11.527 4.622-6.93 1.156.771-4.622 6.93zM7.904 10.363l4.622-6.93 1.156.77-4.622 6.931zM11.376 12.67l4.616-6.934 1.157.77-4.616 6.935zM39.287 25.857l2.12-3.178 1.156.771-2.12 3.178zM33.32 27.305l2.118-3.179 1.156.771-2.118 3.179zM36.783 29.614l2.118-3.18 1.157.771-2.118 3.18zM35.049 28.457l2.119-3.178 1.156.771-2.119 3.179zM37.55 24.699l2.12-3.179 1.156.772-2.119 3.178zM35.415 23.42l2.1-3.17 1.154.764-2.1 3.17z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.07 45.38a8.33 8.33 0 1 1 2.31 11.55 8.33 8.33 0 0 1-2.31-11.55",
    style: {
      fill: "#ff0006"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.77 48.85A4.16 4.16 0 0 0 50 50a4.16 4.16 0 0 1-6.93-4.62 8.33 8.33 0 0 0 13.86 9.24 4.15 4.15 0 0 0-1.16-5.77",
    style: {
      fill: "#0040ab"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.814 10.266 1.157-.77 2.119 3.178-1.157.77zM36.781 4.202l1.157-.771 2.119 3.178-1.157.771zM39.28 7.955l1.156-.772 2.121 3.178-1.156.771zM33.02 6.71l1.154-.764 2.1 3.17-1.153.765z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 0.35,
    x: 37.07,
    y: 8.21
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 0.35,
    x: 38.8,
    y: 8.31
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.055 5.357 1.156-.771 4.62 6.93-1.156.772zM37.17 8.53l.19.29zM38.71 8.34l-.19-.29zM11.383 21.136l1.157-.77 4.62 6.93-1.156.771zM9.644 22.298l1.157-.771 2.118 3.178-1.156.771zM11.18 25.86l-2.11-3.18-1.16.77 4.62 6.93 1.16-.77-2.31-3.47zM12.14 26.05l1.156-.771 2.12 3.178-1.157.771z"
  })));
};
export default SvgNnIconFlagsKrDelivery;